import React from 'react';
import { useSpinnerStyle, SPINNER_STYLES } from '../contexts/SpinnerContext';

const SpinnerStyleToggle = () => {
    const { spinnerStyle, setSpinnerStyle } = useSpinnerStyle();

    return (
        <select
            value={spinnerStyle}
            onChange={(e) => setSpinnerStyle(e.target.value)}
            aria-label="Loading indicator style"
            title="Loading indicator style"
            className="text-xs bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1.5"
        >
            <option value={SPINNER_STYLES.DOTS}>Dots</option>
            <option value={SPINNER_STYLES.PRINTER}>Printer</option>
        </select>
    );
};

export default SpinnerStyleToggle;
